import { ChangeDetectionStrategy, Component, computed, input, InputSignal, Signal } from '@angular/core';

export type SzPasswordStrength = 0 | 1 | 2 | 3 | 4;

@Component({
  selector: 'sz-password-strength-meter',
  templateUrl: './sz-password-strength-meter.component.html',
  styleUrls: ['./sz-password-strength-meter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class SzPasswordStrengthMeterComponent {
  readonly strength: InputSignal<SzPasswordStrength> = input<SzPasswordStrength>(0);

  readonly bars: Signal<ReadonlyArray<number>> = computed((): ReadonlyArray<number> => [0, 1, 2, 3]);

  isActive(idx: number): boolean {
    return idx < this.strength();
  }

  toneClass(): string {
    const s: SzPasswordStrength = this.strength();
    if (s <= 1) return 'tone-error';
    if (s === 2) return 'tone-warn';
    if (s === 3) return 'tone-ok';
    return 'tone-ok-glow';
  }
}
